module.exports = __webpack_public_path__ + "static/media/agenda-tres-dias.8f0be5ad.svg";